import React from "react";
import { MenaVstupy, PercentaVstupy, IntegerVstupy } from "../vstupneKomponenty";

export default function InvesticneVstupneParametreKarta({
  porovnanieInvesticii,
  setPorovnanieInvesticii,
  aktivnyInvesticnyVariant,
  setAktivnyInvesticnyVariant,
  investicnyProfil,
  setInvesticnyProfil,
  setZhodnotenie,
  jednorazovyVklad,
  setJednorazovyVklad,
  jednorazovyPrivkladZapnuty,
  setJednorazovyPrivkladZapnuty,
  jednorazovyPrivklad,
  setJednorazovyPrivklad,
  jednorazovyPrivkladMesiac,
  setJednorazovyPrivkladMesiac,
  mesacnyVklad,
  setMesacnyVklad,
  cielovaSuma,
  setCielovaSuma,
  chybaCielovaSumaRozlozenyPoplatok,
  chybaMesacnyVkladPoplatok,
  chybaMesacnyVkladNavysovanie,
  chybaMesacnyVkladCielovaSuma,
  chybaHorizontCielovaSuma,
  chybaVstupneHodnoty,
  zhodnotenie,
  setZhodnotenieManualne,
  horizont,
  setHorizont,
  dodatocneZhodnocovanieZapnute,
  setDodatocneZhodnocovanieZapnute,
  dodatocneZhodnocovanieRoky,
  setDodatocneZhodnocovanieRoky,
  inflacia,
  setInflacia,
  rezimNavysovaniaVkladu,
  setRezimNavysovaniaVkladu,
  fixneNavysenieVkladu,
  setFixneNavysenieVkladu,
}) {
  const [chybaNavysovanieBezMesacnehoVkladu, setChybaNavysovanieBezMesacnehoVkladu] = React.useState(false);

  const pocetMesiacovHorizontu = Math.min(50, Math.max(0, Number(horizont) || 0)) * 12;
  const dodatocneZhodnocovanieRokyHodnota = dodatocneZhodnocovanieZapnute
    ? Math.min(50, Math.max(0, Number(dodatocneZhodnocovanieRoky) || 0))
    : 0;
  const celkovaDobaInvesticie = Math.min(50, Math.max(0, Number(horizont) || 0)) + dodatocneZhodnocovanieRokyHodnota;
  const najvyssiMesiacPrivkladu = Math.max(0, pocetMesiacovHorizontu - 1);

  const mesiacePrivkladu = React.useMemo(
    () => najvyssiMesiacPrivkladu > 0
      ? Array.from({ length: najvyssiMesiacPrivkladu }, (_, index) => index + 1)
      : [0],
    [najvyssiMesiacPrivkladu]
  );

  const normalizujMesiacPrivkladu = React.useCallback((hodnota) => {
    if (najvyssiMesiacPrivkladu <= 0) return 0;

    return Math.min(
      najvyssiMesiacPrivkladu,
      Math.max(1, Math.floor(Number(hodnota) || 1))
    );
  }, [najvyssiMesiacPrivkladu]);

  const zrusChybuNavysovaniaBezMesacnehoVkladu = React.useCallback(() => {
    if (chybaNavysovanieBezMesacnehoVkladu) {
      setChybaNavysovanieBezMesacnehoVkladu(false);
    }
  }, [chybaNavysovanieBezMesacnehoVkladu]);

  React.useEffect(() => {
    if (Number(mesacnyVklad) > 0) {
      setChybaNavysovanieBezMesacnehoVkladu(false);
      return;
    }

    if (rezimNavysovaniaVkladu !== "ziadne") {
      setRezimNavysovaniaVkladu("ziadne");
    }
  }, [mesacnyVklad, rezimNavysovaniaVkladu, setRezimNavysovaniaVkladu]);

  React.useEffect(() => {
    setChybaNavysovanieBezMesacnehoVkladu(false);
  }, [aktivnyInvesticnyVariant]);

  React.useEffect(() => {
    const normalizovanyMesiac = normalizujMesiacPrivkladu(jednorazovyPrivkladMesiac);

    if (Number(jednorazovyPrivkladMesiac) !== normalizovanyMesiac) {
      setJednorazovyPrivkladMesiac(normalizovanyMesiac);
    }
  }, [jednorazovyPrivkladMesiac, normalizujMesiacPrivkladu, setJednorazovyPrivkladMesiac]);

  const nastavProfil = (profil, zhodnotenieProfilu) => {
    setInvesticnyProfil(profil);
    setZhodnotenie(zhodnotenieProfilu);
  };

  const prepniPorovnanie = (checked) => {
    setPorovnanieInvesticii(checked);
    if (!checked) setAktivnyInvesticnyVariant(1);
  };

  const nastavRezimNavysovania = (novyRezim) => {
    if (novyRezim !== "ziadne" && Number(mesacnyVklad) <= 0) {
      setChybaNavysovanieBezMesacnehoVkladu(true);
      setRezimNavysovaniaVkladu("ziadne");
      return;
    }

    setChybaNavysovanieBezMesacnehoVkladu(false);
    setRezimNavysovaniaVkladu(novyRezim);
  };

  const chybaVstupneParametrePolozky = [
    (chybaMesacnyVkladCielovaSuma || chybaMesacnyVkladNavysovanie || chybaNavysovanieBezMesacnehoVkladu) ? "mesačný vklad" : null,
    chybaHorizontCielovaSuma ? "horizont" : null,
  ].filter(Boolean);

  const chybaVstupneParametreText = chybaVstupneParametrePolozky.length
    ? `Zadaj: ${chybaVstupneParametrePolozky.join(", ")}`
    : "";

  return (
    <div className="card-section card-section--invest-vstup">
      <div className="card-header invest-card-head">
        <h2>Vstupné parametre investície:</h2>

        <div className="invest-header-actions">
          <label className="chk invest-porovnanie-toggle">
            Porovnanie
            <input
              type="checkbox"
              checked={porovnanieInvesticii}
              onChange={(e) => prepniPorovnanie(e.target.checked)}
            />
          </label>

          <div className="applicant-tabs invest-variant-tabs">
            <button
              type="button"
              className={`applicant-tab ${aktivnyInvesticnyVariant === 1 ? "is-active" : ""}`}
              onClick={() => setAktivnyInvesticnyVariant(1)}
            >
              Variant 1
            </button>

            {porovnanieInvesticii && (
              <button
                type="button"
                className={`applicant-tab ${aktivnyInvesticnyVariant === 2 ? "is-active" : ""}`}
                onClick={() => setAktivnyInvesticnyVariant(2)}
              >
                Variant 2
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="inv-mode-row">
        <span className="inv-mode-label"><strong>Investičný profil:</strong></span>

        <div className="inv-toggles">
          <div className="pp-stepper">
            <button
              type="button"
              className={`pp-step ${investicnyProfil === "konzervativny" ? "is-active" : ""}`}
              onClick={() => nastavProfil("konzervativny", 4)}
            >
              Konzervatívny
            </button>

            <button
              type="button"
              className={`pp-step ${investicnyProfil === "vyvazeny" ? "is-active" : ""}`}
              onClick={() => nastavProfil("vyvazeny", 6)}
            >
              Vyvážený
            </button>

            <button
              type="button"
              className={`pp-step ${investicnyProfil === "dynamicky" ? "is-active" : ""}`}
              onClick={() => nastavProfil("dynamicky", 9)}
            >
              Dynamický
            </button>
          </div>
        </div>
      </div>

      <div className="form-group form-group--cols3 invest-form-fluid">
        <div className="form form--m">
          <label className="form_label">Jednorazovo</label>
          <MenaVstupy
            value={jednorazovyVklad}
            onChange={(v) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setJednorazovyVklad(Math.min(9999999, Math.max(0, v)));
            }}
            maxDigits={7}
            suffix="€"
            placeholder="0"
          />
        </div>

        <div className={`form form--m ${(chybaMesacnyVkladPoplatok || chybaNavysovanieBezMesacnehoVkladu) ? "form--error" : ""}`}>
          <label className="form_label">Mesačne</label>
          <MenaVstupy
            value={mesacnyVklad}
            onChange={(v) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setMesacnyVklad(Math.min(99999, Math.max(0, v)));
            }}
            maxDigits={5}
            suffix="€"
            placeholder="0"
          />
        </div>

        <div className={`form form--m ${chybaHorizontCielovaSuma ? "form--error" : ""}`}>
          <label className="form_label">Horizont (r)</label>
          <IntegerVstupy
            value={horizont}
            onChange={(v) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setHorizont(Math.min(50, Math.max(0, v)));
            }}
            maxDigits={2}
            min={0}
            max={50}
            placeholder=" "
          />
        </div>
      </div>

      <div className="form-group form-group--cols3 invest-form-fluid">
        <div className={`form form--m ${chybaCielovaSumaRozlozenyPoplatok ? "form--error" : ""}`}>
          <label className="form_label">Cieľová suma (CS)</label>
          <MenaVstupy
            value={cielovaSuma}
            onChange={(v) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setCielovaSuma(Math.min(9999999, Math.max(0, v)));
            }}
            maxDigits={7}
            suffix="€"
            placeholder="0"
          />
        </div>

        <div className="form form--m">
          <label className="form_label">Zhodnotenie p.a.</label>
          <PercentaVstupy
            value={zhodnotenie}
            onChange={(v) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setZhodnotenieManualne(Math.min(99, Math.max(0, v)));
            }}
            maxInt={2}
            placeholder=" "
          />
        </div>

        <div className="form form--m">
          <label className="form_label">Inflácia p.a.</label>
          <PercentaVstupy
            value={inflacia}
            onChange={(v) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setInflacia(Math.min(99, Math.max(0, v)));
            }}
            maxInt={2}
            placeholder=" "
          />
        </div>
      </div>

      <div className="parametre-divider" />

      <div className="form-group form-group--cols3 invest-form-fluid">
        <div className="form form--m">
          <label className="form_label">&nbsp;</label>

          <label className="chk invest-navysenie-check">
            <input
              type="checkbox"
              checked={jednorazovyPrivkladZapnuty}
              onChange={(e) => {
                zrusChybuNavysovaniaBezMesacnehoVkladu();
                setJednorazovyPrivkladZapnuty(e.target.checked);
              }}
            />
            <span>Jednorazový prívklad:</span>
          </label>
        </div>

        <div className="form form--m">
          <label className="form_label">Suma</label>
          <MenaVstupy
            value={jednorazovyPrivklad}
            onChange={(v) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setJednorazovyPrivklad(Math.min(9999999, Math.max(0, v)));
            }}
            maxDigits={7}
            suffix="€"
            placeholder="0"
          />
        </div>

        <div className="form form--m">
          <label className="form_label">v mesiaci č.:</label>
          <select
            className="form_select"
            value={jednorazovyPrivkladMesiac}
            onChange={(e) => {
              zrusChybuNavysovaniaBezMesacnehoVkladu();
              setJednorazovyPrivkladMesiac(normalizujMesiacPrivkladu(e.target.value));
            }}
          >
            {mesiacePrivkladu.map((mesiac) => (
              <option key={mesiac} value={mesiac}>
                {mesiac}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="invest-navysenie-row">
        <label className="chk invest-navysenie-check">
          <input
            type="checkbox"
            checked={rezimNavysovaniaVkladu !== "ziadne"}
            onChange={(e) => nastavRezimNavysovania(e.target.checked ? "inflacia" : "ziadne")}
          />
          <span>Každoročné navýšenie mes. vkladov o:</span>
        </label>

        <div className="invest-navysenie-controls">
          <div className={`pp-stepper ${rezimNavysovaniaVkladu === "ziadne" ? "is-disabled" : ""}`}>
            <button
              type="button"
              className={`pp-step ${rezimNavysovaniaVkladu === "inflacia" ? "is-active" : ""}`}
              onClick={() => nastavRezimNavysovania("inflacia")}
            >
              Infláciu
            </button>

            <button
              type="button"
              className={`pp-step ${rezimNavysovaniaVkladu === "fix" ? "is-active" : ""}`}
              onClick={() => nastavRezimNavysovania("fix")}
            >
              Fixnú sumu
            </button>
          </div>

          {rezimNavysovaniaVkladu === "fix" && (
            <div className="form form--s invest-navysenie-input">
              <MenaVstupy
                value={fixneNavysenieVkladu}
                onChange={(v) => setFixneNavysenieVkladu(Math.min(99999, Math.max(0, v)))}
                maxDigits={5}
                suffix="€"
                placeholder="0"
              />
            </div>
          )}
        </div>
      </div>

      <div className="form-group form-group--cols3 invest-form-fluid invest-dodatocne-grid">
        <div className="form form--m invest-dodatocne-left">
          <label className="chk invest-navysenie-check invest-dodatocne-check">
            <input
              type="checkbox"
              checked={dodatocneZhodnocovanieZapnute}
              onChange={(e) => {
                zrusChybuNavysovaniaBezMesacnehoVkladu();
                setDodatocneZhodnocovanieZapnute(e.target.checked);
                if (!e.target.checked) setDodatocneZhodnocovanieRoky(0);
              }}
            />
            <span>Dodatočné zhodnocovanie bez vkladov:</span>
          </label>

          <div className="form form--s invest-dodatocne-input">
            <label className="form_label">Počet rokov</label>
            <IntegerVstupy
              value={dodatocneZhodnocovanieZapnute ? dodatocneZhodnocovanieRoky : 0}
              onChange={(v) => {
                const upravenaHodnota = Math.min(50, Math.max(0, v));

                zrusChybuNavysovaniaBezMesacnehoVkladu();
                setDodatocneZhodnocovanieRoky(upravenaHodnota);
                setDodatocneZhodnocovanieZapnute(upravenaHodnota > 0);
              }}
              maxDigits={2}
              min={0}
              max={50}
              placeholder=" "
            />
          </div>
        </div>

        <div className="form form--m invest-dodatocne-celkova-wrap">
          <label className="form_label">&nbsp;</label>

          <div className="inv-mode-label invest-dodatocne-celkova">
            Celková doba investície:{"\u00A0"}<strong>{celkovaDobaInvesticie}</strong>{"\u00A0"}r
          </div>
        </div>
      </div>

      <div className={`inv-hint pp-hint error ${(chybaVstupneHodnoty || chybaVstupneParametreText) ? "" : "is-placeholder"}`}>
        {chybaVstupneParametreText || "Zadajte vstupné hodnoty"}
      </div>
    </div>
  );
}